<template>
  <div class="notification-list">
    <!-- Jobs en cours -->
    <div v-if="activeJobs.length" class="jobs-section">
      <div v-for="job in activeJobs" :key="job.jobId" class="job-item" :class="{ error: job.percent < 0 }">
        <div class="job-message">{{ job.message }}</div>
        <div v-if="job.percent >= 0" class="job-progress-bar">
          <div class="job-progress-fill" :style="{ width: job.percent + '%' }" />
        </div>
        <div v-else class="job-error-text">Erreur</div>
      </div>
    </div>

    <div v-if="notifications.length === 0 && !activeJobs.length" class="no-notifications">
      Aucune nouvelle notification.
    </div>
    <ul v-if="notifications.length">
      <li v-for="notification in notifications" :key="notification.id" class="notification-item" :class="{'unread': !notification.read}" @click="onNotificationClick(notification)">
        <router-link :to="notification.link" class="notification-link">
          <p>{{ notification.content }}</p>
          <small>{{ formatNotificationDate(notification.createdAt) }}</small>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { computed } from 'vue';
import { notificationStore } from '@/store/notificationStore';

export default {
  name: 'NotificationList',
  setup() {
    const notifications = computed(() => notificationStore.notifications);
    const activeJobs = computed(() =>
      Object.entries(notificationStore.jobs).map(([jobId, job]) => ({ jobId, ...job }))
    );

    const onNotificationClick = (notification) => {
      notificationStore.markAsRead(notification);
    };

    const formatNotificationDate = (dateString) => {
      const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(dateString).toLocaleDateString('fr-FR', options);
    };

    return { notifications, activeJobs, onNotificationClick, formatNotificationDate };
  },
};
</script>

<style scoped>
.notification-list {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.no-notifications {
  text-align: center;
  color: #6c757d;
  padding: 10px 0;
}

/* Jobs en cours */
.jobs-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.job-item {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 5px;
  padding: 8px 10px;
}
.job-item.error {
  background: #ffeaea;
  border-color: #f5c6cb;
}

.job-message {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 6px;
}

.job-progress-bar {
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
}

.job-progress-fill {
  height: 100%;
  background: #ffc107;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.job-error-text {
  font-size: 0.75rem;
  color: #dc3545;
}

/* Notifications */
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.notification-item {
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  cursor: pointer;
}

.notification-item.unread {
  font-weight: bold;
  background-color: #e9f5ff;
}

.notification-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.notification-item p {
  margin: 0 0 5px 0;
  color: #495057;
  font-size: 0.95rem;
}

.notification-item small {
  color: #6c757d;
  font-size: 0.8rem;
}
</style>
